<div id="outer" class="well container">
    <div class="col-md-12 well-content">
        <div style="width: 100%">
            <img
                alt="Sedona Technologies"
                class="genericCenter"
                style="width: 150px; margin: 0 auto; display: block"
                src="assets/images/Sedonatek_Logo-300w.webp" />
            <br />
            <div class="panel panel-default" style="margin-top: 15px">
                <div class="panel-heading">Software Information</div>
                <div class="panel-body">
                    <table class="aboutTable">
                        <tr>
                            <td style="vertical-align: top; text-transform: uppercase">
                                <p class="aboutTableHeader">Version</p>
                            </td>
                            <td>{{ appVersion }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
